import React, { Component } from 'react';
import { Translate } from "react-localize-redux";
import { connect } from 'react-redux';

import { ChangeNavbar } from '../../actions';

import './InfoHouse.css';

import {
  Container,
  Row,
  Col
} from 'reactstrap';


class InfoHouse extends Component {
  constructor(props) {
    super(props);
    this.props.SetHeaderNavbar(false);
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    const unityScript = document.createElement("script");
    unityScript.src = process.env.PUBLIC_URL + "/infohouse/Build/UnityLoader.js";
    unityScript.async = false;
    const progressScript = document.createElement("script");
    progressScript.src = process.env.PUBLIC_URL + "/infohouse/LoadData/UnityProgress.js";
    progressScript.async = false;
    const loadScript = document.createElement("script");
    loadScript.src = process.env.PUBLIC_URL + "/infohouse/UnityWebgl.js";
    loadScript.async = false;
    document.body.appendChild(unityScript);
    document.body.appendChild(progressScript);
    document.body.appendChild(loadScript);
  }

  render() {
    return (
      <div className="content">
        <section>
          <Container>
            <Row>
              <Col lg="8" className="mx-auto text-center">
                <h2 className="title"><Translate id="interactive_model.title">Maqueta Interactiva</Translate></h2>
                <hr className="hr-line" />
              </Col>
            </Row>
            <Row>
              <Col lg="12" className="mx-auto text-center">
                <div className="webgl-content">
                  <button type="button" className="btn btn-primary" id="fullscreen_request" style={{display: "none"}}><i className="fas fa-expand"></i></button>
                  <div id="unityContainer" style={{width: "100%", height: "100%"}}></div>
                </div>
              </Col>
            </Row>
          </Container>

          <br/>
          <Container>
            <Row>
              <Col lg="12" className="mx-auto text-justify">
                <hr className="hr-line" />
                <Translate id="interactive_model.text">
                  Las maquetas 3D son una manera excelente de visualizar proyectos de construcción, arquitectura o ingeniería. 
                  <br/><br/>
                  Además de generar <i>renders</i> de gran calidad, desarrollamos aplicaciones que permiten interactuar con las maquetas en tiempo real.
                  Esto es ideal para presentación de proyectos ante potenciales clientes, o para permitir a los usuarios de las instalaciones visualizarlas desde su PC o teléfono.
                </Translate>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
      );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SetHeaderNavbar: (haveHeader) => {dispatch(ChangeNavbar(haveHeader))}
  }
}

function mapStateToProps(state) {
  return {  }
}

export default connect (
  mapStateToProps,
  mapDispatchToProps
)(InfoHouse);
